import React from 'react';

const ComingSoon = ({ 
  title = "Coming Soon",
  subtitle = "This page is under development",
  description = "We're working hard to bring you this feature. Stay tuned for updates!",
  showImage = true 
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-8">
        {/* Icon/Image */}
        {showImage && (
          <div className="mx-auto w-32 h-32 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center shadow-lg">
            <svg
              className="w-16 h-16 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        )}

        {/* Content */}
        <div className="space-y-4">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 font-poppins">
            {title}
          </h1>
          
          <h2 className="text-xl md:text-2xl text-gray-600 font-medium font-poppins">
            {subtitle}
          </h2>
          
          <p className="text-gray-500 leading-relaxed max-w-sm mx-auto font-poppins">
            {description}
          </p>
        </div>

        {/* Progress indicator */}
        <div className="space-y-4">
          <div className="flex justify-center space-x-2">
            <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"></div>
            <div className="w-3 h-3 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
          
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-gradient-to-r from-blue-500 to-purple-600 h-2 rounded-full animate-pulse" style={{ width: '65%' }}></div>
          </div>
          
          <p className="text-sm text-gray-400 font-poppins">Development in progress...</p>
        </div>

        {/* Additional info */}
        <div className="pt-4 border-t border-gray-200">
          <p className="text-xs text-gray-400 font-poppins">
            Expected completion: Soon
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon; 